var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('create-new-category',{attrs:{"error-text":_vm.errorText,"mode":"create"},on:{"on-save-btn-click":function($event){return _vm.saveCategory($event)},"input":_vm.resetError}})}
var staticRenderFns = []

export { render, staticRenderFns }